import { Typography } from '@mui/material'
import React from 'react'

import { GAME_FACT_START } from '../constants.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapStart = ({state, match, inHistory}) => {
    const {timer, comment, title, period} = state

    const [img] = useGameFact({type : GAME_FACT_START})

    const actualPeriod =  period ??  match.period
  
    return (
      <div style={{color : inHistory ? 'black' : 'white'}}>
        <img src={img} width={150}/>
        <Typography>Titre : {title}</Typography>
        <Typography>Commentaire : {comment}</Typography>
        {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
      </div>
    )
  }

export default RecapStart